import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Email Template API
 */
class EmailTemplateApi extends ApiBase {
  /**
   * Check if Email Template description already exists
   * @param {*} description
   */
  async checkDescriptionExists(description) {
    const request = {
      url: `${this.API_URL}/mailtemplate?description=${description}`,
      headers: this.getHeaders(),
      method: 'HEAD',
      validateStatus: function(status) {
        return (
          (status >= 200 && status < 300) || status === 404 || status === 403
        );
      }
    };

    const response = await axios.request(request);

    if (response.status === 200 || response.status === 403) {
      // Email template description is used, in case of 403 it's not visible to the user
      return true;
    } else if (response.status === 404) {
      return false;
    }
  }
}

export default new EmailTemplateApi();
